import React, { useEffect } from "react";
import { useState } from "react";
import styles from "./checkbox.module.css";

export const CheckboxInput = (props: any) => {
  const { value, className, onChange, type, label } = props;

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }
  , [value]);

  return (
    <div className={styles.checkbox}>
      <input
        type="checkbox"
        onChange={(e) => {
          setInputValue(e.target.checked);
          if (onChange) {
            onChange(e.target.checked);
          }
        }}
        checked={inputValue}
      />
      {label && <div className={styles.checkbox_description}>{label}</div>}
    </div>
  );
};
